import {colors} from "@c10h/colors";
import Link from "next/link";
import {useTranslation} from "ni18n";
import React, {useEffect, useState} from "react";
import {Controller, Scene} from "react-scrollmagic";

import {dev, v5Pages} from "../../_common/_constants";
import {dly} from "../../_common/Carbon";
import {Btn} from "../V5Comp";
import styles from "./Header.module.scss";

const Header = ({getStartedTracker}: any) => {
  const i18n = useTranslation();

  const [id, setId] = useState(null);
  const [h, setH] = useState(1000);

  useEffect(() => {
    dly(() => {
      const layout = document.getElementById("layout");
      // @ts-expect-error TS2531: Object is possibly 'null'.
      setH(layout.offsetHeight);
    }, 0);
  }, []);

  const items = [
    {
      id: 1,
      title: i18n.t("How It Works"),
      link: "#how",
      dotColor: colors.yellow,
    },
    {
      id: 2,
      title: i18n.t("Resources"),
      link: "#resources",
      dotColor: colors.purple,
    },
    {
      id: 3,
      title: i18n.t("Testing"),
      link: "#servicesWrap",
      dotColor: colors.mint,
    },
    {
      id: 4,
      title: i18n.t("Pricing"),
      link: "#pricing",
      dotColor: colors.mint,
    },
    {
      id: 5,
      title: i18n.t("FAQ"),
      link: "#faq",
      dotColor: colors.blue,
    },
  ];

  return (
    <div className={styles.outerWrap}>
      <Controller>
        <Scene
          triggerHook={0}
          offset={1}
          triggerElement="#layout"
          duration={h}
          indicators={dev}
          classToggle="stick"
        >
          <div className={styles.wrap}>
            <Link href={{pathname: v5Pages.home}}>
              <span className={`${styles.l} cIcon-covidReadyLogo`} aria-hidden />
              <span className="visually-hidden">Covid Ready by Carbon Health</span>
            </Link>
            <div className={`${styles.r} basic ${id ? "hoveredParent" : ""}`}>
              <div className={styles.rInner}>
                {items.map(a => (
                  <a
                    href={a.link}
                    className={`${styles.r1} ${a.id === id ? "hoveredA" : ""}`}
                    key={a.id}
                    style={{"--dotColor": a.dotColor}}
                    // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'SetStateAction<null>'.
                    onMouseEnter={() => setId(a.id)}
                    onMouseLeave={() => setId(null)}
                  >
                    {a.title}
                  </a>
                ))}
              </div>

              <div className={styles.r2}>
                <Btn
                  href="#signup"
                  color={colors.gray800}
                  bg={colors.gray50}
                  hover={colors.gray50}
                  hoverBg={colors.gray800}
                  fontSize="14px"
                  className={styles.r22}
                  onClick={getStartedTracker}
                >
                  {i18n.t("Get started")}
                </Btn>
              </div>
            </div>
          </div>
        </Scene>
      </Controller>
    </div>
  );
};

export default Header;
